import { IBreadcrumb } from '../../types/newbuilding';
import { IApplicationState } from '../../types/redux';

export const selectBreadcrumbs = (state: IApplicationState): IBreadcrumb[] => {
  const { breadcrumbs } = state.newbuildingData;

  return breadcrumbs;
};
